import EADialog from "components/common/EADialog";
import i18next from "i18next";
import useStyles from "./CreditsafePanelStyle";
import { theme } from "style/globalStyle";

const NationalScoreDetailsModal = ({ isOpen, onClose }) => {
    const { classes } = useStyles();

    return (
        <EADialog isOpen={isOpen} onClose={onClose} title={i18next.t("creditsafe.scores.nationalScoreValue")} maxWidth="lg" hasActions={false}>
            <div className={classes.gridColumns}>

                <div className={classes.scoreDetailsContent}>
                    <span className={classes.scoreBadge}
                        style={{ backgroundColor: "#2D9F40" }}>{"71 - 100"}</span>
                    {i18next.t("creditsafe.localScoresValues.very_low")}
                </div>
                <div className={classes.scoreDetailsContent}>
                    <span className={classes.scoreBadge}
                        style={{ backgroundColor: theme.palette.primary.primary400 }}>{"51 - 70"}</span>
                    {i18next.t("creditsafe.localScoresValues.low")}
                </div>
                <div className={classes.scoreDetailsContent}>
                    <span className={classes.scoreBadge}
                        style={{ backgroundColor: theme.palette.warning.warning600 }}>{"30 - 50"}</span>
                    {i18next.t("creditsafe.localScoresValues.medium")}
                </div>
                <div className={classes.scoreDetailsContent}>
                    <span className={classes.scoreBadge}
                        style={{ backgroundColor: theme.palette.warning.warning500 }}>{"21 - 29"}</span>
                    {i18next.t("creditsafe.localScoresValues.high")}
                </div>
                <div className={classes.scoreDetailsContent}>
                    <span className={classes.scoreBadge}
                        style={{ backgroundColor: theme.palette.error.error600 }}>{"1 - 20"}</span>
                    {i18next.t("creditsafe.localScoresValues.very_high")}
                </div>
                <div className={classes.scoreDetailsContent}>
                    <span className={classes.scoreBadge}
                        style={{ backgroundColor: theme.palette.error.error600 }}>{"0"}</span>
                    {i18next.t("creditsafe.localScoresValues.default")}
                </div>
                <div className={classes.scoreDetailsContent}>
                    <span className={classes.scoreBadge}
                        style={{ backgroundColor: theme.palette.grey.grey400 }}>{"NC"}</span>
                    {i18next.t("creditsafe.localScoresValues.no_score")}
                </div>
            </div>

        </EADialog>
    )

}
export default NationalScoreDetailsModal;